import {
  addDays,
  addMonths,
  addWeeks,
  addYears,
  areRangesOverlapping,
  endOfDay,
  endOfMonth,
  endOfToday,
  endOfWeek,
  endOfYear,
  getISOWeek,
  getMonth,
  isEqual,
  max,
  min,
  startOfDay,
  startOfMonth,
  startOfToday,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subWeeks,
  subYears
} from 'date-fns';
import { Day } from '../store';

export function isDiffusionDay(flag: number, day: Day): boolean {
  return (flag & day) !== 0;
}

export function daysForDiffusionFlag(flag: number): number[] {
  const days = [];
  if (isDiffusionDay(flag, Day.Sunday)) {
    days.push(0);
  }
  if (isDiffusionDay(flag, Day.Monday)) {
    days.push(1);
  }
  if (isDiffusionDay(flag, Day.Tuesday)) {
    days.push(2);
  }
  if (isDiffusionDay(flag, Day.Wednesday)) {
    days.push(3);
  }
  if (isDiffusionDay(flag, Day.Thursday)) {
    days.push(4);
  }
  if (isDiffusionDay(flag, Day.Friday)) {
    days.push(5);
  }
  if (isDiffusionDay(flag, Day.Saturday)) {
    days.push(6);
  }
  return days;
}

export const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const fullDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

// Days
export const today = () => ({
  startDate: startOfToday(),
  endDate: endOfToday()
});
export const previousDay = (fromDate: Date) => {
  const date = subDays(startOfDay(fromDate), 1);
  return { startDate: startOfDay(date), endDate: endOfDay(date) };
};
export const nextDay = (fromDate: Date) => {
  const date = addDays(startOfDay(fromDate), 1);
  return { startDate: startOfDay(date), endDate: endOfDay(date) };
};
export const nameOfTheDay = (day: number | Date): string => {
  if (day instanceof Date) {
    day = day.getDay();
  }
  return dayNames[day];
};

export const fullNameOfTheDay = (day: number | Date): string => {
  if (day instanceof Date) {
    day = day.getDay();
  }
  return fullDayNames[day];
};

// Weeks
export const thisWeek = () => ({
  startDate: startOfWeek(new Date()),
  endDate: endOfWeek(new Date())
});
export const previousWeek = (fromDate: Date) => {
  const date = subWeeks(startOfWeek(fromDate), 1);
  return { startDate: startOfWeek(date), endDate: endOfWeek(date) };
};
export const nextWeek = (fromDate: Date) => {
  const date = addWeeks(startOfWeek(fromDate), 1);
  return { startDate: startOfWeek(date), endDate: endOfWeek(date) };
};
export const numberOfWeek = (fromDate: Date) => getISOWeek(fromDate);

// Months
export const nextMonth = (fromDate: Date) => {
  const date = addMonths(startOfMonth(fromDate), 1);
  return { startDate: startOfMonth(date), endDate: endOfMonth(date) };
};
export const previousMonth = (fromDate: Date) => {
  const date = subMonths(startOfMonth(fromDate), 1);
  return { startDate: startOfMonth(date), endDate: endOfMonth(date) };
};
export const nameOfTheMonth = (fromDate: Date) => monthNames[getMonth(fromDate)];

export const thisMonth = () => ({
  startDate: startOfMonth(new Date()),
  endDate: endOfMonth(new Date())
});

// Years
export const thisYear = () => ({
  startDate: startOfYear(new Date()),
  endDate: endOfYear(new Date())
});
export const nextYear = (fromDate: Date) => {
  const date = addYears(startOfYear(fromDate), 1);
  return { startDate: startOfYear(date), endDate: endOfYear(date) };
};
export const previousYear = (fromDate: Date) => {
  const date = subYears(startOfYear(fromDate), 1);
  return { startDate: startOfYear(date), endDate: endOfYear(date) };
};

export const getOverlappingRange = (
  sd1: Date,
  ed1: Date,
  sd2: Date,
  ed2: Date
): { overlap: boolean; start: Date; end: Date } => {
  if (areRangesOverlapping(sd1, ed1, sd2, ed2)) {
    return { overlap: true, start: max(sd1, sd2), end: min(ed1, ed2) };
  }
  return { overlap: false, start: new Date(), end: new Date() };
};

export const getTimeOnly = (date: Date) => {
  const newDate = new Date(date.getTime());
  newDate.setFullYear(1);
  newDate.setMonth(0);
  newDate.setDate(1);
  return newDate;
};

export const getDiffRange = (sd1: Date, ed1: Date, sd2: Date, ed2: Date) => {
  const overlap = getOverlappingRange(sd1, ed1, sd2, ed2);
  if (!overlap.overlap) {
    return {
      left: { start: sd1, end: ed1 },
      common: null,
      right: { start: sd2, end: ed2 }
    };
  }

  return {
    left: !isEqual(sd1, sd2)
      ? {
          start: min(sd1, sd2),
          end: max(sd1, sd2)
        }
      : null,
    common: { start: overlap.start, end: overlap.end },
    right: !isEqual(ed1, ed2)
      ? {
          start: min(ed1, ed2),
          end: max(ed1, ed2)
        }
      : null
  };
};



// WEBPACK FOOTER //
// ./src/viewModes/utils.ts